module.exports = __webpack_public_path__ + "static/media/6.8239b08f.wav";